import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2.ts';
import { PERSONALIZED_CATALOGS_V3 } from '../constants/abTestsConstants.ts';

export const ITEM_PRICE_IN_SELLABILITY = 'ItemPriceInSellability' as const;
export const TRADE_QUICK_FILTERS = 'TradeQuickFilters' as const;
export const URGENCY_SIGNALS_MW = 'CartUrgencySignalMWv2' as const;
export const TABLE_SIZE_FILTER = 'TableSizeFilter' as const;
export const SHIPPING_COST_SB = 'ShippingCostSB' as const;
export const CONTENT_VISIBILITY_SB = 'ContentVisibilitySB' as const;
export const SHIPS_FROM_SB_TILE = 'ShipsFromSBTile' as const;
const PDP_BOTTOM_NEW_SL_MODULE = 'PDP_bottom_new_SL_module' as const;
export const QUICK_FILTERS_REDESIGN = 'quick_filters_redesign' as const;
export const REMOVE_COUNTS = 'remove_counts' as const;
export const VECTOR_SEARCH_FALLBACK = 'vector_search_fallback' as const;

export const getShippingCostSbVariant = (): string | undefined =>
    getAbTestV2(SHIPPING_COST_SB)?.variant;

export const getIsShipsFromSBTileVariant = (getAbTestFunc = getAbTestV2): boolean =>
    getAbTestFunc(SHIPS_FROM_SB_TILE)?.variant === 'variant';

export const getIsPdpBottomNewSlModuleTestVariant = (): boolean =>
    getAbTestV2(PDP_BOTTOM_NEW_SL_MODULE)?.variant === 'variant';

export const getIsPersonalizedCatalogsV3Variant = (): boolean =>
    getAbTestV2(PERSONALIZED_CATALOGS_V3)?.variant === 'variant';

export const trackPdpBottomNewSlModuleTest = (): void => {
    trackAbTestV2Variant(PDP_BOTTOM_NEW_SL_MODULE);
};

export const trackQuickFiltersRedesignTest = (): void => {
    trackAbTestV2Variant(QUICK_FILTERS_REDESIGN);
};
